import Vue from 'vue';
import { Toast } from 'mint-ui';
import 'mint-ui/lib/toast/style.css';

import './style.less';

const toast = Toast;

export default {
  show(message, options = {}) {
    return new Promise((resolve) => {
      const instance = toast({
        message,
        className: options.className || 'vue-toast__style',
        ...options,
      });

      setTimeout(() => {
        instance.close();
        resolve();
      }, options.duration || 2000);
      Vue.prototype.$moduleExpose({
        pageId: 'show-toast',
        moduleId: 'show-toast',
        businessInfo: {
          message,
        },
      });
    });
  },
  showError(error, options, callback) {
    if (error && error.type !== 'no_show' && error.message) {
      return this.show(error.message, options, callback);
    }
    return Promise.resolve();
  },
  clearToasts(selector) {
    const toastEls = document.querySelectorAll(selector || '.mint-toast');
    [].forEach.call(toastEls, (el) => {
      // eslint-disable-next-line no-param-reassign
      el.className = el.className.replace('mint-toast-show', '');
    });
  },
};
